import React, { useState, useEffect } from 'react';
import { Spin, Alert } from 'antd';
import { usePW9336Query } from './hooks/usePW9336Query';
import QueryParams from './components/QueryParams';
import ResultTable from './components/ResultTable';
import type { QueryRequest } from '../../services/pw9336Api';
import './PW9336Form.css';

const PW9336Form: React.FC = () => {
  const { loading, result, queried, noData, defaultYear, defaultMonth, runQuery } = usePW9336Query();

  const [year, setYear] = useState(defaultYear);
  const [month, setMonth] = useState(defaultMonth);

  // Sync defaults when loaded from server
  useEffect(() => {
    setYear(defaultYear);
    setMonth(defaultMonth);
  }, [defaultYear, defaultMonth]);

  const handleQuery = () => {
    const req: QueryRequest = {
      year,
      month,
    };
    runQuery(req);
  };

  return (
    <Spin spinning={loading}>
      <div className="pw9336-container max-w-7xl mx-auto p-4">
        <h2 className="text-xl font-bold mb-4">
          薪資印領清冊 (pw9336f1)
        </h2>

        <QueryParams
          year={year}
          month={month}
          loading={loading}
          onYearChange={setYear}
          onMonthChange={setMonth}
          onQuery={handleQuery}
        />

        {queried && !noData && result && (
          <ResultTable result={result} />
        )}

        {queried && noData && (
          <Alert
            message="查無資料"
            description="查無符合條件的薪資資料！請確認年度月份是否正確。"
            type="info"
            showIcon
          />
        )}
      </div>
    </Spin>
  );
};

export default PW9336Form;
